// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2vaFS","title":"FrontImage_title__zj2Fd"};